export default {
    computed: {
        isMobile() {
            return this.$vuetify.breakpoint.smAndDown
        },
        isMobileMd() {
            return this.$vuetify.breakpoint.mdAndDown
        },
        isMobileXxs() {
            return this.$vuetify.breakpoint.xsOnly
        },
        isMobileXs() {
            return window.innerHeight < 500
        },
        isIOS() {
            const ios = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream

            return ios
        },
    },
};